import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["disabled", "title", "onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-export-to-pdf" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["disabled", "title", "onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-preview" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["disabled", "title", "onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-document-compare" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["disabled", "title", "onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-download" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_AddressOutput = _resolveComponent("AddressOutput")!
  const _component_ParempiGrid = _resolveComponent("ParempiGrid")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ParempiGrid, {
      class: "flex-grow-1 plotTaskItemList",
      items: this.items,
      columns: this.columns
    }, {
      selectionHeader: _withCtx(() => [
        _createVNode(_component_CheckBox, {
          mode: "flex",
          disabled: this.asyncRunning,
          modelValue: this.selectionAll,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.selectionAll) = $event)),
          onChange: this.selectAllClicked
        }, null, 8, ["disabled", "modelValue", "onChange"])
      ]),
      document: _withCtx(({ item }) => [
        _createElementVNode("div", {
          class: _normalizeClass('text-break ' + (item.documentVersion.status==3||item.documentVersion.status==4||item.documentVersion.status==7?'text-decoration-line-through':''))
        }, _toDisplayString(item.documentVersion.name), 3),
        _createElementVNode("div", {
          class: _normalizeClass('text-break ' + (item.documentVersion.status==3||item.documentVersion.status==4||item.documentVersion.status==7?'text-decoration-line-through':''))
        }, _toDisplayString(this.getDocumentContent(item)), 3)
      ]),
      file: _withCtx(({ item }) => [
        (this.showPdfButton(item))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              disabled: this.disabled,
              class: "btn btn-sm btn-outline-secondary",
              "data-bs-toggle": "tooltip",
              title: _ctx.$t('plot.fileIcons.pdfToolTip'),
              onClick: ($event: any) => (_ctx.exportPdf(item))
            }, _hoisted_3, 8, _hoisted_1))
          : _createCommentVNode("", true),
        (this.showPngButton(item))
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              disabled: this.disabled,
              class: "btn btn-sm btn-outline-secondary",
              "data-bs-toggle": "tooltip",
              title: _ctx.$t('plot.fileIcons.pngToolTip'),
              onClick: ($event: any) => (_ctx.exportPng(item))
            }, _hoisted_6, 8, _hoisted_4))
          : _createCommentVNode("", true),
        (this.showCompareButton(item))
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              disabled: this.disabled,
              class: "btn btn-sm btn-outline-secondary",
              "data-bs-toggle": "tooltip",
              title: _ctx.$t('plot.fileIcons.compareToolTip'),
              onClick: ($event: any) => (_ctx.compareDocumentVersion(item))
            }, _hoisted_9, 8, _hoisted_7))
          : _createCommentVNode("", true),
        (this.showSaveButton(item))
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              disabled: this.disabled,
              class: "btn btn-sm btn-outline-secondary",
              "data-bs-toggle": "tooltip",
              title: _ctx.$t('plot.fileIcons.saveToolTip'),
              onClick: ($event: any) => (_ctx.downloadDocumentVersion(item))
            }, _hoisted_12, 8, _hoisted_10))
          : _createCommentVNode("", true)
      ]),
      paperQuality: _withCtx(({ item }) => [
        _createElementVNode("div", {
          class: _normalizeClass('text-break ' + (item.documentVersion.status==3||item.documentVersion.status==4||item.documentVersion.status==7?'text-decoration-line-through':''))
        }, _toDisplayString(item.plotProperties.paperQuality), 3)
      ]),
      color: _withCtx(({ item }) => [
        _createElementVNode("div", {
          class: _normalizeClass('text-break ' + (item.documentVersion.status==3||item.documentVersion.status==4||item.documentVersion.status==7?'text-decoration-line-through':''))
        }, _toDisplayString(this.getPlotColor(item)), 3)
      ]),
      margin: _withCtx(({ item }) => [
        _createElementVNode("div", {
          class: _normalizeClass('text-break ' + (item.documentVersion.status==3||item.documentVersion.status==4||item.documentVersion.status==7?'text-decoration-line-through':''))
        }, _toDisplayString(item.plotProperties.margin), 3)
      ]),
      mirror: _withCtx(({ item }) => [
        _createElementVNode("div", {
          class: _normalizeClass('text-break ' + (item.documentVersion.status==3||item.documentVersion.status==4||item.documentVersion.status==7?'text-decoration-line-through':''))
        }, _toDisplayString(this.getPlotMirror(item)), 3)
      ]),
      scale: _withCtx(({ item }) => [
        _createElementVNode("div", {
          class: _normalizeClass('text-break ' + (item.documentVersion.status==3||item.documentVersion.status==4||item.documentVersion.status==7?'text-decoration-line-through':''))
        }, _toDisplayString(item.plotProperties.scale), 3)
      ]),
      count: _withCtx(({ item }) => [
        _createElementVNode("div", {
          class: _normalizeClass('text-break ' + (item.documentVersion.status==3||item.documentVersion.status==4||item.documentVersion.status==7?'text-decoration-line-through':''))
        }, _toDisplayString(this.getPlotCount(item)), 3)
      ]),
      area: _withCtx(({ item }) => [
        _createElementVNode("div", {
          class: _normalizeClass('text-break ' + (item.documentVersion.status==3||item.documentVersion.status==4||item.documentVersion.status==7?'text-decoration-line-through':''))
        }, _toDisplayString(this.getPlotArea(item)), 3)
      ]),
      pages: _withCtx(({ item }) => [
        _createElementVNode("div", {
          class: _normalizeClass('text-break ' + (item.documentVersion.status==3||item.documentVersion.status==4||item.documentVersion.status==7?'text-decoration-line-through':''))
        }, _toDisplayString(item.documentVersion.numberOfPages), 3)
      ]),
      deliveryAddress: _withCtx(({ item }) => [
        _createElementVNode("div", {
          class: _normalizeClass('text-break ' + (item.documentVersion.status==3||item.documentVersion.status==4||item.documentVersion.status==7?'text-decoration-line-through':''))
        }, [
          _createVNode(_component_AddressOutput, {
            address: this.getDeliveryAddress(item),
            personal: "true"
          }, null, 8, ["address"])
        ], 2)
      ]),
      type: _withCtx(({ item }) => [
        _createElementVNode("div", {
          class: _normalizeClass('text-break ' + (item.documentVersion.status==3||item.documentVersion.status==4||item.documentVersion.status==7?'text-decoration-line-through':''))
        }, _toDisplayString(this.getTypeLabel(item)), 3)
      ]),
      choose: _withCtx(({ item }) => [
        _createVNode(_component_CheckBox, {
          mode: "flex",
          modelValue: item.chosen,
          "onUpdate:modelValue": ($event: any) => ((item.chosen) = $event),
          onChange: this.selectClicked
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
      ]),
      _: 1
    }, 8, ["items", "columns"]),
    _createVNode(_component_Dialog, {
      ref: "pngDialog",
      buttons: _ctx.CLOSE,
      title: _ctx.$t('plot.task.pngDialogTitle', { documentVersionName : this.pngDialogDocumentVersion }),
      extraClasses: ['d-flex', 'justify-content-center', 'modal-xl', 'modal-dialog-centered']
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: this.pngDialogSrc
        }, null, 8, _hoisted_13)
      ]),
      _: 1
    }, 8, ["buttons", "title"])
  ], 64))
}